import { connect } from 'react-redux'
import { reset } from 'redux-form'
import { moveStep, estimationReset, creationReset } from 'store/ducks/delivery'
import NavBarButton from 'views/components/presentationals/NavBarButton'

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
  onClick: () => {
    dispatch(estimationReset())
    dispatch(creationReset())
    dispatch(moveStep(0))
    dispatch(reset('delivery'))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(NavBarButton)
